import React, { FC, PropsWithChildren } from 'react';

// This is just a type trick to work around type error where i18nIsDynamicList
// does not exist (used by react-i18enext)
export const DynamicTranslation: FC<PropsWithChildren<{ i18nIsDynamicList: boolean }>> = (prop) => (
  <span>{prop.children}</span>
);
